/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../reducer/reducer'
import {StatisticsWidget5} from '../statistics/StatisticsWidget5'
import {MDBBtn, MDBCard, MDBCardBody, MDBCardText, MDBCardTitle, MDBCol} from 'mdb-react-ui-kit'
import FadeIn from 'react-fade-in'
import {Installment} from '../../../../app/modules/accounts/components/items/Installment'
import {FiCopy} from 'react-icons/fi'

import Coin from '../../../../assets/salecooperation/1339-sale-lineal.webp'
import {Link} from 'react-router-dom'
import {MDBSpinner} from 'mdb-react-ui-kit'
import GraphSvg from '../../../../../src/assets/sections/Graph.svg'
import ChartSvg from '../../../../../src/assets/sections/Chart.svg'
import toast, {Toaster} from 'react-hot-toast'
import Tippy from '@tippy.js/react'
import {CopyToClipboard} from 'react-copy-to-clipboard'

type Props = {
  className?: string
  chartColor: string
  strokeColor: string
  chartHeight: string
}

const MixedWidget2: React.FC<Props> = ({className, chartColor, chartHeight, strokeColor}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const dispatch = useDispatch()

  const UserInfo = useSelector((state: RootState) => {
    return state.UserInfo
  })

  const Copied = () => {
    toast.success('لینک دعوت شما کپی شد میتوانید این لینک را برای دوستان خود ارسال کنید')
  }

  const [payment, setPayment] = useState([
    {
      row: '1',
      title: 'قسط آبان ماه ',
      desc: 'قسط سوم با کد 50500',
      price: 50000,
      date: '1400.4.7',
      status: '',
      pay: '',
    },
    {
      row: '2',
      title: 'قسط آذر ماه ',
      desc: 'قسط چهارم با کد 50501',
      price: 90000,
      date: '1400.4.8',
      status: '',
      pay: '',
    },
    {
      row: '3',
      title: 'قسط دی ماه ',
      desc: 'قسط پنجم با کد 50502',
      price: 100000,
      date: '1400.4.9',
      status: '',
      pay: '',
    },
    {
      row: '4',
      title: 'قسط بهمن ماه ',
      desc: 'قسط هفتم با کد 50503',
      price: 120000,
      date: '1400.4.10',
      status: '',
      pay: '',
    },
  ])

  return (
    <>
      <FadeIn>
        <div className={`card p-4 ${className}`}>
          <Toaster />
          <div className='row g-5 g-xl-8'>
          <div className='col-xl-12'>
          <Link to={'/stock/transfer'}>
          <StatisticsWidget5
                  className='card-xl-stretch mb-2 bg-card-red-light-sales mb-xl-4'
                  svgIcon={ChartSvg}
                  iconColor='white'
                  title=' سهام های من '
                  description='مشاهده لیست سهام'
                />
              </Link>
            </div>
            <div className='col-xl-6'>
              <Link to={'/stock/transfer'}>
                <StatisticsWidget5
                  className='card-xl-stretch mb-2 bg-section-green mb-xl-4'
                  svgIcon={GraphSvg}
                  iconColor='white'
                  title='   انتقال سهام   '
                  description='ثبت درخواست انتقال'
                />
              </Link>
            </div>
            <div className='col-xl-6'>
              <Link to={'/stock/orders'}>
                <StatisticsWidget5
                  className='card-xl-stretch mb-2 bg-section-gray mb-xl-4'
                  svgIcon={ChartSvg}
                  iconColor='white'
                  title='سفارشات سهام'
                  description='پرداخت ها - قرارداد'
                />
              </Link>
            </div>

          </div>
          <MDBCard dir={'rtl'} className={'bg-card-sales '}>
            <MDBCardBody className={'m-2 '}>
              <MDBCardTitle className={'mt-4'}>
                <h1 className={'text-white font-light '}>همکاری در فروش سهام</h1>
              </MDBCardTitle>
              <br />
              <MDBCardText
                style={{flexDirection: 'column-reverse'}}
                className={'mt-4 h-4/12 flex flex-sm-column flex-md-column flex-lg-row text-white'}
              >
                <div className={'flex flex-col'}>
                  جهت همکاری در فروش سهام، کد زیر را برای فرد مورد نظر خود ارسال کنید تا از سود معرف
                  خرید، بهره مند شوید.
                  <br />
                  <br />
                  <Tippy
                    placement='top'
                    className='tippy'
                    arrow={false}
                    content={<span style={{color: 'white'}}> برای کپی کلیک کنید</span>}
                  >
                    <div
                      onClick={Copied}
                      className={'mt-2 text-center flex flex-col items-center justify-center'}
                    >
                      <>
                        {UserInfo.UserInfo ? (
                          <CopyToClipboard
                            text={`https://panel.mehriranianco.ir/auth/registration?ref=${UserInfo.UserInfo.referral_code}`}
                          >
                            <MDBBtn
                              color={
                                'white mt-1 flex justify-center items-center sm:w-full lg:w-5/12'
                              }
                            >
                              کد معرف شما :{UserInfo.UserInfo.referral_code}
                              <div className={'mr-5 bg-primary rounded'}>
                                <FiCopy className={'text-white m-2'} />
                              </div>
                            </MDBBtn>
                          </CopyToClipboard>
                        ) : (
                          <MDBSpinner role='status'>
                            <span className='visually-hidden'>Loading...</span>
                          </MDBSpinner>
                        )}
                      </>
                      <br />
                      <Link to={'sale/cooperation'}>
                        <div>
                          <MDBBtn
                            outline
                            style={{border: '1px solid white', borderRadius: 25}}
                            rounded
                            className='mx-2 mt-5 text-light text-white'
                          >
                            اطلاعات بیشتر
                          </MDBBtn>
                        </div>
                      </Link>
                    </div>
                  </Tippy>
                </div>
                <div className={'text-center flex justify-center'}>
                  <img src={Coin} width={150} alt='coin' />
                </div>
              </MDBCardText>
              <br />
            </MDBCardBody>
          </MDBCard>

          <br />
          <hr className={'mt-5 mb-5'} />
          <div className='text-right'>
            <h3 className='mr-8 mb-6'>سفارشات اخیر </h3>
          </div>
          <div className={'w-full h-full flex-col text-center flex justify-center items-center'}>
            {/* <h1 className='bi bi-calendar-check text-lg fs-2x' /> */}
            {payment ? <Installment /> : <p>هیچ قسطی برای پرداخت شما وجود ندارد</p>}

            {/* <Button onClick={() => dispatch(LOG_OUT())}>log out</Button> */}
            {/* <MDBInput label='Example label' id='form1' type='text' /> */}
          </div>
        </div>
      </FadeIn>
    </>
  )
}

export default MixedWidget2
